import styled from "@emotion/native";
import Button from "../../../../components/Button";
import Text from "../../../../components/Text";

export const Main = styled.View({
    flex: 1,
    flexDirection: "column",
    justifyContent: "flex-start",
});

export const Cta = styled(Button)({
    marginHorizontal: 20,
    marginVertical: 40,
});

export const CtaContainer = styled.View({
    justifyContent: "flex-end",
    paddingBottom: 40,
    flex: 1,
});

// minor adjustment to give multi-select questions a little more room to breathe.
export const ProgressMulti = styled(Text)({
    // marginTop: -40,
    textAlign: "center",
    marginBottom: 17,
});

export const Priorities = styled.View({
    marginTop: 38,
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-between",
    marginBottom: 12,
});

export const Priority = styled.View({
    display: "flex",
    flexDirection: "column",
    alignContent: "flex-start",
    alignItems: "center",
    justifyContent: "flex-start",
    width: 100,
});

export const PriorityLabel = styled(Text)({
    textAlign: "center",
});

export const PriorityIcon = styled.Image({
    width: 60,
    height: 60,
    marginVertical: 12,
    alignSelf: "center",
    resizeMode: "contain",
});

export const PriorityLevel = styled(Text)({
    textAlign: "center",
    // borderWidth: 1,
    // borderColor: "red",
});
